// extracted by mini-css-extract-plugin
export default {"card":"I4-z"};